/* eslint no-unused-vars: 0  */
/* global $ */
import { gsap, Power3 } from 'gsap';

/*
  Any custom project animations
*/

/* eslint-disable */
function msieversion() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    // If IE return true
    return true;
  } else {
    // If another browser, return 0
    return false;
  }
}
const bTest = msieversion();

/* eslint-enable */
const logo = document.getElementById('dj-logo');
const djdem = logo.getElementById('dj-demand');
const djjust = logo.getElementById('dj-justice');
const dcut = logo.getElementById('dj-cut-demand');
const jcut = logo.getElementById('dj-cut-justice');
const tl = gsap.timeline({ paused: true });

if (!bTest) {
  tl.to(djdem, { opacity: 0, duration: 0 })
    .to(djjust, { opacity: 0, duration: 0 })
    .to(dcut, { scaleX: 0, duration: 0 })
    .to(jcut, { scaleX: 0, duration: 0 })
    .to(logo, { opacity: 1, duration: 0 })
    .to(dcut, { ease: Power3.easeOut, scaleX: 1, duration: 0.8 }, 0.2)
    .to(djdem, { ease: Power3.easeOut, opacity: 1, duration: 0.4 }, '-=0.8s')
    .to(jcut, { ease: Power3.easeOut, scaleX: 1, duration: 0.8 }, '-=0.4')
    .to(djjust, { ease: Power3.easeOut, opacity: 1, duration: 0.4 }, '-=0.8s');


  // play animation after 1.5s
  setTimeout(() => {
    tl.play();
  }, 1500);

  // restart animation on hover
  $('.main-logo a').on('mouseenter', () => {
    tl.restart();
  });
} else {
  $('.dj-logo').addClass('dj-logo-go');
}

